import { useMatch } from 'react-router-dom'
import { ButtonLink } from '@applyboard/crystal-ui'
import { IconType } from '@applyboard/crystal-ui/lib/types/design'
interface INavBarItem {
  children: string | undefined
  id: string
  href: string
  label: string
  icon: IconType
}

export function NavBarItem(props: INavBarItem) {
  const match = useMatch(props.href)

  return (
    <ButtonLink
      href={props.href}
      leadIcon={props.icon}
      width="fill"
      intent={!!match ? 'primary' : 'secondary'}
      emphasis={!!match ? 'highlighted' : 'transparent'}
      aria-label={props.label}
    >
      {props.children}
    </ButtonLink>
  )
}
